function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Startup file which initializes the AIOT Tree. You can access the exports
 * through <code>window.rml</code>.
 *
 * @module rml
 */
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import { ready, hooks, rmlOpts, i18n, urlParam, ajax, applyNodeDefaults, fetchTree, findDeep, humanFileSize, secondsFormat, dataUriToBlob, addUrlParam, uri, isMaterialWp, IS_DARKMODE, urlBuilder, request } from "./util";
import optionsScreen from "./others/optionsScreen";
import applyMediaViews, { firstCreatedToolbar } from "./others/mediaViews";
import { anyKeyHolding } from "./util/dragdrop";
import store, { injectAndObserve, TreeNode, Upload, StoredAppTree } from "./store";
import "./style/style.scss";
import "../lib/react-aiot/src/style/theme-wordpress.scss";
import "./hooks";
import "./others/static";
import "./util/wpRfc";
import "./others/exportMediaLibrary";
import "./others/defaultFolder";
import { handleCorrupRestApi } from "@devowl-wp/utils";
handleCorrupRestApi === null || handleCorrupRestApi === void 0 ? void 0 : handleCorrupRestApi(_defineProperty({}, rmlOpts.restNamespace, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return request({
            location: {
              path: "/plugin",
              // `rmlOpts.restNamespace` uses the legacy namespace, for /plugin we need to force the new namespace
              namespace: "real-media-library/v1"
            }
          });

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})))); // ReplaceWith should return the new object

!$.fn.replaceWithPush && ($.fn.replaceWithPush = function (a) {
  var $a = $(a);
  this.replaceWith($a);
  return $a;
});
/**
 * General event when script for RML is ready to load.
 *
 * @event module:util/hooks#general
 */

hooks.call("general");
applyMediaViews();
ready(function () {
  // Add rml-touch class if touch device
  if ("ontouchstart" in window || window.navigator.maxTouchPoints) {
    $("body").addClass("rml-touch");
  }

  anyKeyHolding();
  "WebkitAppearance" in document.documentElement.style && $("body").addClass("rml-webkit");

  if (rmlOpts && $("body").hasClass("wp-admin") && ($("body").hasClass("upload-php") || // MLA compatibility
  $("body").hasClass("media_page_mla-menu"))) {
    var $container, container;
    var containerId = "rml" + rmlOpts.others.blogId;
    /**
     * General event when DOM is ready and a list table / grid mode
     * is available in media library page.
     *
     * @event module:util/hooks#ready
     */

    hooks.call("ready"); // Avoid flickering

    $("#wpbody").fadeTo(100, 1); // Create the container sidebar

    $("body").addClass("activate-aiot");
    $container = $("<div/>").prependTo("body.wp-admin #wpbody").addClass("rml-container");
    container = $container.get(0); // Create the wrapper and React component, the modal react element is created in hooks/modal.js

    if (rmlOpts.others.listMode === "grid") {
      // When in grid mode, we have to wait for the first attachments browser
      firstCreatedToolbar.done(function (attachmentsBrowser) {
        ReactDOM.render( /*#__PURE__*/React.createElement(StoredAppTree, {
          attachmentsBrowser: attachmentsBrowser,
          id: containerId
        }), container);
      });
    } else {
      ReactDOM.render( /*#__PURE__*/React.createElement(StoredAppTree, {
        id: containerId
      }), container);
    }
  } // Wait for modals


  if (process.env.PLUGIN_CTX === "pro") {
    /* onlypro:start */
    hooks.register("attachmentsBrowser/modal/dom/ready", function (container) {
      if (!rmlOpts) return;

      try {
        hooks.call("attachmentsBrowser/modal/exception", [container], this);

        var _containerId = "rml" + rmlOpts.others.blogId,
            useStore = container.$el.parents(".media-frame").data("useStore");

        ReactDOM.render( /*#__PURE__*/React.createElement(StoredAppTree, {
          attachmentsBrowser: this,
          isModal: true,
          id: _containerId,
          useStore: useStore
        }), container.el);
      } catch (e) {// Silence is golden.
      }
    });
    /* onlypro:end */
  } // Options panel


  $("body").hasClass("options-media-php") && optionsScreen();
});
IS_DARKMODE && $("body").addClass("aiot-wp-dark-mode");
isMaterialWp() && $("body").addClass("aiot-wp-material");
export {
/**
 * @type module:util/hooks
 */
hooks
/**
 * @type object
 */
, rmlOpts
/**
 * @type module:util.i18n
 */
, i18n
/**
 * @type module:util.urlParam
 */
, urlParam
/**
 * @type module:util.ajax
 */
, ajax
/**
 * @type module:util.applyNodeDefaults
 */
, applyNodeDefaults
/**
 * @type module:util.fetchTree
 */
, fetchTree
/**
 * @type module:util.findDeep
 */
, findDeep
/**
 * @type module:util.humanFileSize
 */
, humanFileSize
/**
 * @type module:util.secondsFormat
 */
, secondsFormat
/**
 * @type module:util.dataUriToBlob
 */
, dataUriToBlob
/**
 * @type module:util/addUrlParam
 */
, addUrlParam
/**
 * @see https://github.com/lil-js/uri
 * @type function
 */
, uri
/**
 * @type module:store.injectAndObserve
 */
, injectAndObserve
/**
 * @type module:store~store
 */
, store
/**
 * @type module:store/TreeNode~TreeNode
 */
, TreeNode
/**
 * @type module:store/Upload~Upload
 */
, Upload
/**
 * @type module:store.StoredAppTree
 */
, StoredAppTree
/**
 * @type function
 */
, urlBuilder
/**
 * @type function
 */
, request };